import type { TFunction } from 'i18next'

/** Labels may already be translated by their caller. A matching namespace
 * object (for example `Send`) must never become visible diagnostic text. */
export function translateDisplayLabel(t: TFunction, label: string): string {
  const translated = t(label, { returnObjects: true })
  return typeof translated === 'string' ? translated : label
}
